
import { IQuestionSkill as EditorQuestionSkill } from '../../types'
import OriginalQuestionSkill from '../../../api/v2/models/skill'
import OriginalQuestionSkillItem from '../../../api/v2/models/skill_item'

export default class SkillComparison {
    constructor(readonly originalQuestionSkills: OriginalQuestionSkill[] | null, readonly originalQuestionSkillItems: OriginalQuestionSkillItem[] | null, readonly editorQuestionSkills: EditorQuestionSkill | null) {}

    get isSame(){
        if (!this.editorQuestionSkills || !this.originalQuestionSkills) {
            return false
        }
        return JSON.stringify(originalQuestionSkillArray(this.originalQuestionSkills, this.originalQuestionSkillItems))==JSON.stringify(editorQuestionSkillArray(this.editorQuestionSkills))
    }
}

const originalQuestionSkillArray = (originalQuestionSkills: OriginalQuestionSkill[], originalQuestionSkillItems: OriginalQuestionSkillItem[]) => {
    const arr = []
    originalQuestionSkills.forEach(originalQuestionSkill => {
        originalQuestionSkill.skillItems.forEach(skillItem => {
            if (originalQuestionSkillItems.find(item => item.id == skillItem.id)) {
                arr.push(`${originalQuestionSkill.name}_${skillItem.name}`)
            }
        })
    });
    arr.sort()
    return arr
}

const editorQuestionSkillArray = (editorQuestionSkills: EditorQuestionSkill) => {
    const arr = []
    Object.keys(editorQuestionSkills).forEach(name => {
        editorQuestionSkills[name].forEach(skillItem => {
            let resultMatching = `${name}_${skillItem.name}_${skillItem.criteria}`
            let answerItemsAttributes = skillItem.answerItemsAttributes

            if (answerItemsAttributes) {
              answerItemsAttributes.forEach(answerItem => {
                Object.keys(answerItem).forEach(answerItemKey => {
                  resultMatching += `_${answerItem[answerItemKey]}`
                })
              })
            }
            arr.push(resultMatching)
        });
    });
    arr.sort()
    return arr
}
